import { useReactiveVar } from "@apollo/client";
import {
  CAROUSEL_BREAK_POINTS,
  MIN_LANDSCAPE_ITEM_NUM,
  MIN_RANKING_ITEM_NUM,
  MIN_SQUARE_ITEM_NUM,
  SP_BREAK_SIZE,
  SP_VERICAL_ITEM_NUM,
} from "~/components/blocks/vod/top/const";
import { windowWidthVar } from "~/components/blocks/vod/top/store";
import { useMatchMedia } from "~/hooks/use-match-media";
import { ROOT_PADDING } from "~/styles/padding";

type Props = {
  /** SP時の最小幅 */
  SP: number;
  /** Tablet時の最小幅 */
  TABLET: number;
  /** PC時の最小幅 */
  PC: number;
  /** MONITOR時の最小幅 */
  MONITOR: number;
  /** RANKINGか判定 */
  IS_RANKING: boolean;
  /** SQUAREか判定 */
  IS_SQUARE: boolean;
  /** LANDSCAPEか判定 */
  IS_LANDSCAPE: boolean;
  /** 高さの比率, aspect比のheightの比率をnumberで渡す */
  heightRatio: number;
};

const PC_SCROLL_PADDING = 32;
const SP_SCROLL_PADDING = 16;

export const useTopDisplayItemCount = ({
  SP,
  TABLET,
  PC,
  MONITOR,
  IS_RANKING,
  IS_SQUARE,
  IS_LANDSCAPE,
  heightRatio,
}: Props) => {
  const { isSpSize } = useMatchMedia();
  const windowWidth = useReactiveVar(windowWidthVar) || window.innerWidth;

  const isMonitor = CAROUSEL_BREAK_POINTS.MONITOR <= windowWidth;
  const isPc = CAROUSEL_BREAK_POINTS.PC <= windowWidth && windowWidth <= CAROUSEL_BREAK_POINTS.MONITOR;
  const isTablet = CAROUSEL_BREAK_POINTS.TABLET <= windowWidth && windowWidth <= CAROUSEL_BREAK_POINTS.PC;

  const minWidth = isMonitor ? MONITOR : isPc ? PC : isTablet ? TABLET : SP;
  const padding = (isMonitor || isPc || isTablet ? ROOT_PADDING.PC : ROOT_PADDING.SP) * 2;

  const displayItemCountFunc = (): number => {
    const ItemCount = Math.floor((windowWidth - padding) / minWidth);

    if (IS_RANKING && MIN_RANKING_ITEM_NUM >= ItemCount) {
      return MIN_RANKING_ITEM_NUM;
    }
    if (IS_SQUARE && MIN_SQUARE_ITEM_NUM >= ItemCount) {
      return MIN_SQUARE_ITEM_NUM;
    }
    if (IS_LANDSCAPE && MIN_LANDSCAPE_ITEM_NUM >= ItemCount) {
      return MIN_LANDSCAPE_ITEM_NUM;
    }
    if (SP_BREAK_SIZE > windowWidth) {
      return SP_VERICAL_ITEM_NUM;
    }
    return ItemCount;
  };

  const displayItemCount = displayItemCountFunc();

  const itemWidth = Math.floor(
    (windowWidth - (isSpSize ? SP_SCROLL_PADDING : PC_SCROLL_PADDING) * 2) / displayItemCount
  );
  const itemHeight = Math.floor(itemWidth * heightRatio);
  const imageSrcSize = {
    itemWidth,
    itemHeight,
  };

  return {
    displayItemCount,
    imageSrcSize,
  };
};
